import {request} from '@weplanet-web/core'

const PATH = '/userStatuses'

function getUserStatuses() {
  return request<IGetUserStatuses>({url: PATH, method: 'GET'})
}

export {getUserStatuses}
